import script from "./homeIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./homeIndex.vue?vue&type=script&lang=ts&setup=true"

import "./homeIndex.vue?vue&type=style&index=0&id=782eec7b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782eec7b"]])

export default __exports__